import { render, staticRenderFns } from "./MassPatientList.vue?vue&type=template&id=4bad4f78&scoped=true"
import script from "./MassPatientList.vue?vue&type=script&lang=js"
export * from "./MassPatientList.vue?vue&type=script&lang=js"
import style0 from "./MassPatientList.vue?vue&type=style&index=0&id=4bad4f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bad4f78",
  null
  
)

export default component.exports